import { createSlice } from "@reduxjs/toolkit";

const globalStore = createSlice({
  name: "global",
  initialState: {
    adminProfile: null,
    userProfile: null,
    siteSetting: null,
  },
  reducers: {
    setAdminProfile: (state, action) => {
      state.adminProfile = action.payload;
    },
    resetAdminProfile: (state) => {
      state.adminProfile = null;
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    resetUserProfile: (state) => {
      state.userProfile = null;
    },
    setSiteSetting: (state, action) => {
      state.siteSetting = action.payload;
    },
    resetSiteSetting: (state) => {
      state.siteSetting = null;
    },
  },
});

export const {
  setAdminProfile,
  resetAdminProfile,
  setSiteSetting,
  setUserProfile,
  resetSiteSetting,
  resetUserProfile,
} = globalStore.actions;
export default globalStore.reducer;
